<template>
  <div class="tip-video-container">
    <div class="sys-max-width">

      <div class="ccc lg-mx">
        <div class="icon"></div>
        <div class="text">当前账号为非授权账号，无法观看视频教程，请向管理员申请相关权限。</div>
      </div>
    </div>
  </div>
</template>

<script>



export default {
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  },
  created() {

  }
}
</script>

<style lang="scss">
.tip-video-container {
  background: $bg;

  .sys-max-width {
    padding: 140px 0px 140px;

    .ccc {
      .icon {
        width: 64px;
        height: 64px;
        background: url(~@/assets/no-icon.png) no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
      }

      .text {
        font-size: 14px;
        font-weight: 400;
        color: #3C4858;
        line-height: 46px;
        text-align: center;
      }
    }

    // .tip {
    //   color: #3C4858;
    //   text-align: center;
    //   font-size: 22px;
    // }

  }
}
</style>
